const componentStyles = (theme) => ({
  bgDefault: {
    backgroundColor: theme.palette.white.main,
  },
});

export default componentStyles;
